import React from "react";
import { Link } from "react-router-dom";

export default function Pricing() {
  return (
    <main className="py-10">
      <div className="container-x">
        {/* Header */}
        <header className="mb-8 text-center md:text-left">
          <p className="uppercase tracking-[0.2em] text-[#D4FF00] font-extrabold text-xs">Pricing</p>
          <h1 className="text-4xl font-extrabold mt-1">Simple, Flexible, no surprises.</h1>
          <p className="text-neutral-400 mt-2 max-w-[760px]">
            Book by the hour or grab a day pass. Group packages available for parties and events.
          </p>
        </header>

        {/* Plans */}
        <section className="grid gap-4 md:grid-cols-3">
          {/* Hourly */}
          <article className="card p-5 flex flex-col">
            <h3 className="text-xl font-bold">Hourly</h3>
            <p className="text-neutral-400 mb-4">Jump in for a quick session.</p>
            <div className="text-4xl font-extrabold mb-4">
              <span className="text-white"><s>$8</s><span className="text-accent"> $4</span></span>
              <span className="text-neutral-400 text-xl">/hr</span>
            </div>
            <ul className="text-sm text-neutral-300 space-y-2 mb-6">
              <li>• 144–240Hz PC or console bay</li>
              <li>• Fiber internet</li>
              <li>• Access to installed titles*</li>
            </ul>
            <Link to="/booking" className="btn btn-accent text-center mt-auto">Book Hour</Link>
          </article>

          {/* Day Pass */}
          <article className="card p-5 flex flex-col">
            <h3 className="text-xl font-bold">Day Pass</h3>
            <p className="text-neutral-400 mb-4">In for the long grind.</p>
            <div className="text-4xl font-extrabold mb-4">
              <span className="text-[#D4FF00]">$30</span>
              <span className="text-neutral-400 text-xl">/day</span>
            </div>
            <ul className="text-sm text-neutral-300 space-y-2 mb-6">
              <li>• Unlimited play (open–close)</li>
              <li>• Priority seating on return</li>
              <li>• 10% off snacks & drinks</li>
            </ul>
            <Link to="/booking" className="btn btn-accent text-center mt-auto">Get Day Pass</Link>
          </article>

          {/* Party / Group */}
          <article className="card p-5 flex flex-col border-[#3a3a3a]">
            <div className="inline-block bg-[#D4FF00] text-black text-xs font-black px-2 py-1 rounded-full w-max mb-3">Best for Parties</div>
            <h3 className="text-xl font-bold">Party / Group</h3>
            <p className="text-neutral-400 mb-4">Reserve a block of rigs.</p>
            <div className="text-4xl font-extrabold mb-4">
              <span className="text-[#D4FF00]">$199</span>
              <span className="text-neutral-400 text-xl">/2 hrs</span>
            </div>
            <ul className="text-sm text-neutral-300 space-y-2 mb-6">
              <li>• 5 PCs or console bays</li>
              <li>• Host assistance</li>
              <li>• BYO account/logins</li>
            </ul>
            <Link to="/contact" className="btn btn-accent text-center mt-auto">Request Booking</Link>
          </article>
        </section>

        {/* Add-ons */}
        <section className="mt-8 grid gap-4 md:grid-cols-3">
          <article className="card p-5">
            <h4 className="font-bold mb-2">Add-Ons</h4>
            <ul className="text-sm text-neutral-300 space-y-1">
              <li>• Headset rental — <span className="text-[#D4FF00]">$3</span></li>
              <li>• Controller rental — <span className="text-[#D4FF00]">$3</span></li>
              <li>• Private room (per hour) — <span className="text-[#D4FF00]">$15</span></li>
            </ul>
          </article>
          <article className="card p-5">
            <h4 className="font-bold mb-2">Hardware</h4>
            <p className="text-neutral-400 text-sm">
              5 PCs • RTX-class GPUs • 32GB RAM • 144–240Hz monitors • Fiber internet
            </p>
          </article>
          <article className="card p-5">
            <h4 className="font-bold mb-2">Notes</h4>
            <p className="text-neutral-400 text-sm">
              * Some titles may require your own license/account. Prices include taxes where applicable.
            </p>
          </article>
        </section>
      </div>
    </main>
  );
}
